import React, { useEffect, useState } from "react";
import axiosInstance from "../../api/utils/axiosInstance";
import { Spinner } from "react-bootstrap";
import "./temp.css";
import { toast } from "react-toastify";
import { Button } from "antd";
import { PKI_PROTOCOL } from "../../constants/constants";

export const SignatureComponent = ({zahtjevAtrId, handleCancel, dataType, handleFinished}) => {
	const [authData, setAuthData] = useState();
	const [authError, setAuthError] = useState();
	const [isLoading, setIsLoading] = useState(false);
	const [iFrameEventStatus, setIFrameEventStatus] = useState();
	

	useEffect(() => {
		const generateAuthorizationKey = async () => {
			setIsLoading(true);
			try {
				const { data } = await axiosInstance.get(`/signature/v2/getAuthKey/${zahtjevAtrId}?dataType=${dataType}`);
				console.log(data);
				if (data.errorID !== null || data.errorMsg !== null) {
					setAuthError(data);
				} else {
					setAuthData(data);
				}
			} catch (e) {
				let toastMsg = e.response.data.errorMsg ? e.response.data.errorMsg : "Dogdila se neočekivana greška, molimo pokušajte ponovno";
				toast.error(toastMsg, {position: toast.POSITION.BOTTOM_RIGHT});
			} finally {
				setIsLoading(false);
			}
		};
		generateAuthorizationKey();
	}, []);

	useEffect(() => {
		const handleEvent = (event) => {
			const { message, data, origin } = event;
			handleMessage(message || data);
		};

		window.addEventListener("message", handleEvent, false);
		return function cleanup() {
			window.removeEventListener("message", handleEvent);
		};
	});

	const handleMessage = (input) => {
		setIFrameEventStatus(input.value);
	};

	const handleContinue = async () => {
		setIsLoading(true);
		try{
			const res = await axiosInstance.post(`/signature/v2/pullNvData?dataType=${dataType}`, authData);
			toast.info("Dokument uspješno potpisan i spremljen uz zahtjev",{position:toast.POSITION.BOTTOM_RIGHT});
		}catch(e){
			let toastMsg = e.response.data.errorMsg ? e.response.data.errorMsg : "Dogodila se neočekivana greška, molimo pokušajte ponovno";
			toast.error(toastMsg, {position: toast.POSITION.BOTTOM_RIGHT}); 
		}finally{
			setIsLoading(false);
			handleFinished();
		}
	};

	return (
		<>
			{isLoading && (<><div className="spinner-wrapper"></div> <Spinner as="span" animation="border" size="xl" role="status" aria-hidden="true" variant="secondary" /></>)}
			{authData && 
				<iframe id="myIframe" title="Demo" 
					src={`http://localhost:8897?authKey=${authData.authKey}&id=${authData.idZhtvRq}&protocol=${PKI_PROTOCOL}`}
					width="100%" height="750px" sandbox="allow-forms allow-scripts allow-downloads allow-same-origin" allow="clipboard-write" />
      		}{iFrameEventStatus && iFrameEventStatus === "DOCUMENT_SAVED" && (
				<Button block type="primary" onClick={handleContinue}>
					Nastavi
				</Button>
			)}
			<Button block type="danger" onClick={handleCancel}>
				Odustani
			</Button>


			{authError && 
				toast.error(authError.errorMsg)
			}
			
		</>
	);
};
